<template>
  <div :class="['main main__container', cssClasses]">
    <oie-layout-grid css-classes="grid--two">
      <div class="sign-in">
        <h3 v-epi-edit="'LoginHeader'" class="sign-in__header">
          {{ t('loginHeader') }}
        </h3>

        <p class="sign-in__description" v-html="t('signInDescription')">
        </p>
        <oie-sign-in-box
          register-url="registerUrl"
          :fetch-invoice-data="true">
        </oie-sign-in-box>
      </div>

      <div class="sign-in sign-in--register">
        <h3 class="sign-in__header">
          {{ t('newCustomer') }}
        </h3>

        <p class="sign-in__description">
          {{ t('registerDescription') }}
        </p>

        <a :href="registerUrl" class="button button--with-border button--blue sign-in__button">
          {{ t('registerButton') }}
        </a>
      </div>
    </oie-layout-grid>
  </div>
</template>

<script>
export default {
  props: {
    registerUrl: {
      type: String,
      required: true
    },
    activateUrl: {
      type: String,
      required: false,
      default: ''
    },
    referrer: {
      type: String,
      required: false,
      default: ''
    },
    checkOutUrl: {
      type: String,
      required: false,
      default: decodeURIComponent(window.location.search.replace(/\?returnurl=/ig, ''))
    }
  }
}
</script>

<style lang="scss">
.sign-in--register {
  @include media(small) {
    padding-left: calc(#{measure(double)} * 2);
  }

  @include media(medium) {
    padding-left: calc(#{measure(double)} * 4);
  }
}

.sign-in__header {
  @include h2-larger-semi-bold;
  color: color(text-blue);
  margin: 0 measure(half) 0 0;
}

.sign-in__description {
  @include body;
  margin-bottom: measure(full);
}

.sign-in__button {
  width: 100%;

  @include media(small) {
    width: 15rem;
  }
}

.sign-in__as-guest {
  padding-top: measure(double);
}
</style>
